import React, { useEffect, useState } from 'react';
import {
  formatTrialClassSignupCSVData,
  validEmail,
} from '../../../utilities/formatData';
import { Form, Space } from 'antd';
import { getParams } from '../../../utilities/filterConstructor';
import { CSVLink } from 'react-csv';
import {
  getClasses,
  getTrialClassRegistration,
} from '../../../services/trialClassService';
import FilterForm from './FilterForm';
import flagMap from '../../../data/isoCodeMap';
import TableWithSorter from '../../Common/TableWithSorter';

const MAX_LIMIT = 1000;

const TrialClassRegistration = () => {
  const columns = [
    {
      title: 'ID',
      dataIndex: 'index',
      key: 'index',
      render: (value, item, index) => <span>{offset + index + 1}</span>,
    },
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country',
      render: (value) => <span>{value}</span>,
    },
    {
      title: 'ISO Code',
      dataIndex: 'country',
      key: 'country',
      render: (value) => <span>{flagMap[value]?.Code}</span>,
    },
    {
      title: 'Phone No',
      dataIndex: 'phone',
      key: 'phone',
      render: (text, record) => (
        <span>{`${record.dialCode}${record.phone}`}</span>
      ),
    },
    {
      title: 'Class Code',
      dataIndex: 'class',
      key: 'class',
      render: (value) => <span>{value?.classCode}</span>,
    },
    {
      title: 'Class Timezone',
      dataIndex: 'class',
      key: 'class',
      render: (value) => <span>{value?.timezone}</span>,
    },
    {
      title: 'Class Time',
      dataIndex: 'class',
      key: 'class',
      render: (value) => (
        <span>{new Date(value?.startDate).toLocaleDateString()}</span>
      ),
    },
    {
      title: 'Sign up time',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value) => <span>{new Date(value).toLocaleString()}</span>,
    },
  ];

  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [offset, setOffset] = useState((current - 1) * pageSize);

  const [signUps, setSignups] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [error, setError] = useState(false);
  const [currentParams, setCurrentParams] = useState({});
  const [csvReport, setCsvReport] = useState({});
  const [classes, setClasses] = useState([]);

  const getData = (newParams, limit = pageSize, currentPage = current) => {
    const params = newParams ? newParams : currentParams;
    getTrialClassRegistration(currentPage, limit, params)
      .then((res) => {
        if (!res.error) {
          const signUpData = res.data.data.paginatedList.filter((r) =>
            validEmail(r.email)
          );
          setSignups(signUpData);
          setCsvReport(formatTrialClassSignupCSVData(signUpData));
          setTotalCount(res.data.data.totalCount);
        } else {
          console.log(res.error);
          setError(error);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getTrialClasses = () => {
    getClasses(1, MAX_LIMIT, {})
      .then((res) => {
        if (!res.error) {
          const trialClasses = res.data.data.paginatedList;
          const data = trialClasses.map((c) => ({
            label: c.classCode,
            value: c.classCode,
          }));
          setClasses(data);
        } else {
          console.log(res.error);
          setError(error);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const onPaginationChange = (data) => {
    getData(currentParams, data.pageSize, data.current);
    setCurrent(data.current);
    setPageSize(data.pageSize);
    setOffset((data.current - 1) * data.pageSize);
  };

  useEffect(() => {
    getData();
    getTrialClasses();
  }, [current, currentParams]);

  const [form] = Form.useForm();

  const onSearch = (data) => {
    const params = getParams(data);
    setCurrentParams(params);
    setCurrent(1);
  };

  const onReset = () => {
    form.resetFields();
    getData({}, 1);
  };

  return (
    <>
      <div>Total count: {totalCount}</div>
      <div className="filter-div">
        <div className="filter-form-wrapper">
          <FilterForm onSearch={onSearch} onReset={onReset} classes={classes} />
        </div>
        {csvReport.data && csvReport.data.length > 0 ? (
          <CSVLink
            data={csvReport.data}
            headers={csvReport.headers}
            filename={csvReport.filename}
          >
            Export to CSV
          </CSVLink>
        ) : null}
      </div>
      {signUps.length > 0 ? (
        <div>
          `{' '}
          <TableWithSorter
            scroll={{ x: 1000 }}
            columns={columns}
            dataSource={signUps}
            pagination={{
              total: totalCount,
              defaultPageSize: pageSize,
              showSizeChanger: true,
              pageSizeOptions: ['20', '500', '1000', '2000'],
            }}
            onChange={onPaginationChange}
          />
        </div>
      ) : null}
    </>
  );
};

export default TrialClassRegistration;
